<template>
  <div>
    <v-dialog
      v-show="uploadProgressDialog"
      v-model="uploadProgressDialog"
      persistent
      max-width="600px"
      v-scroll-lock="!uploadProgressDialog"
    >
      <v-card>
        <template v-if="!completed">
          <v-card-title>
            <span class="mt-2">
              Uploading...
            </span>
          </v-card-title>
          <v-card-title class="headline justify-center">
            <span>
              DO NOT CLOSE BROWSER
            </span>
          </v-card-title>
        </template>
        <template v-else>
          <v-card-title class="headline justify-center">
            <span>
              <v-icon color="green" large>mdi-check</v-icon>
              Upload success!
            </span>
          </v-card-title>
        </template>
        <v-list-item class="px-6">
          <v-list-item-content class="mt-3 px-3">
            <v-row>
              <v-col cols="3">Structure image</v-col>
              <v-col cols="9">
                <v-progress-linear
                  :value="imageUploadProgress"
                  height="25"
                  stream
                >
                  <strong>{{ imageUploadProgress }}%</strong>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">Cell table</v-col>
              <v-col cols="9">
                <v-progress-linear :value="tableUploadProgress" height="25">
                  <strong>{{ tableUploadProgress }}%</strong>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-btn
                v-if="completed"
                class="mb-5"
                color="error"
                @click="setUploadProgressDialog(false)"
              >
                Close
              </v-btn>
              <v-btn v-else class="mb-5" color="error" @click="cancelUpload()">
                Cancel
              </v-btn>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'UploadProgressDialog',
  props: {
    imageUploadProgress: {
      type: Number,
      required: true,
    },
    tableUploadProgress: {
      type: Number,
      required: true,
    },
    uploadProgressDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    completed: function() {
      return this.imageUploadProgress == 100 && this.tableUploadProgress == 100
    },
  },
  methods: {
    cancelUpload() {
      this.$emit('cancelUpload')
    },
    setUploadProgressDialog(show) {
      this.$emit('setUploadProgressDialog', show)
    },
  },
  mounted() {},
}
</script>
